/**
 * To prevent that people accidentally import multiple flavours of the same type (i.e. @depict-ai/utilishared/latest and @depict-ai/utilishared/ES7) we have this module which needs to not be transformed by babel or bundled by parcel and therefore has to support ES5
 */
var versions_imported = [];

function register_es_version(package_name, es_version) {
  package_name = "@depict-ai/" + package_name;
  var already_imported = [];
  for (var i = 0; i < versions_imported.length; i++) {
    already_imported.push(package_name + "/" + versions_imported[i]);
  }
  var has_this_version = versions_imported.indexOf(es_version) !== -1;
  if (!has_this_version) {
    versions_imported.push(es_version);
  }
  if (versions_imported.length > 1) {
    throw new Error(
      "You're trying to import multiple transpiled versions of " +
        package_name +
        "! Already imported: " +
        already_imported.join(", ") +
        " and you're trying to import " +
        package_name +
        "/" +
        es_version +
        " or a dependant thereof"
    );
  }
}

export { register_es_version };
